import { render, staticRenderFns } from "./overStandard.vue?vue&type=template&id=005cf81b&scoped=true&"
import script from "./overStandard.vue?vue&type=script&lang=js&"
export * from "./overStandard.vue?vue&type=script&lang=js&"
import style0 from "./overStandard.vue?vue&type=style&index=0&id=005cf81b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005cf81b",
  null
  
)

export default component.exports